module.exports = __webpack_public_path__ + "img/ctrl-t-1.2fef09e0.svg";